export class ChristieGsSeries {
    constructor(socket) {
        this.socket = socket;
        this.displayFreeze = false;
        this.firmwareVersion = '1.00';
        this.power = false;
        this.videoInput = '3';
        this.asyncHandlers = [
            {
                name: 'displayFreezeQuery',
                regExp: /\(FRZ\s*\?/i,
                callback: (match) => {
                    this.socket.send(`(FRZ!${this.displayFreeze ? '01' : '00'})`);
                },
            },
            {
                name: 'displayFreezeSet',
                regExp: /\(FRZ\s*(0|1)/i,
                callback: (match) => {
                    this.displayFreeze = match[1] === '1';
                    this.socket.send(`(FRZ!${this.displayFreeze ? '01' : '00'})`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /\(PIF\+FWVS\s*\?/i,
                callback: (match) => {
                    this.socket.send(`(PIF+FWVS!${this.firmwareVersion})`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /\(PWR\s*\?/i,
                callback: (match) => {
                    this.socket.send(`(PWR!${this.power ? '01' : '00'})`);
                },
            },
            {
                name: 'powerSet',
                regExp: /\(PWR\s*(0|1)/i,
                callback: (match) => {
                    this.power = match[1] === '1';
                    this.socket.send(`(PWR!${this.power ? '01' : '00'})`);
                },
            },
            {
                name: 'videoInputQuery',
                regExp: /\(SIN\+MAIN\s*\?/i,
                callback: (match) => {
                    this.socket.send(`(SIN+MAIN!${this.videoInput})`);
                },
            },
            {
                name: 'videoInputSet',
                regExp: /\(SIN\+MAIN\s*([0-9a-f]+)/i,
                callback: (match) => {
                    this.videoInput = match[1];
                    this.socket.send(`(SIN+MAIN!${this.videoInput})`);
                },
            },
        ];
        // Commands are terminated with a ? for queries or . for sets
        this.commandExtractor = {
            terminators: [],
            unterminatedRegExp: /\(.+\s*(?:\d+|\?)\)/,
        };
        this.sendTerminator = '';
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoInput === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoInput = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '3';
    }
}
ChristieGsSeries.emulatorType = 'socketEmulator';
ChristieGsSeries.key = '-NAjvTprma_emWzHRKIJ';
